<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import Multiselect from "vue-multiselect"; // add Multiselect
import { swal } from "../../../helpers/handle_error.js";
import { required, minLength, maxLength, requiredIf } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";

import relative_relation from "../../../helpers/list/relative_relation";
import gender from "../../../helpers/list/gender";
import marital_status from "../../../helpers/list/marital_status";
import certificate from "../../../helpers/list/certificate";
import own_property from "../../../helpers/list/own_property";
import job from "../../../helpers/list/job";
import health_status from "../../../helpers/list/health_status";

export default {
  components: { DatePicker, Multiselect },
  props: {},
  data() {
    return {
      fields: [],

      //lists
      list_relative_relation: relative_relation,
      list_gender: gender,
      list_marital_status: marital_status,
      list_certificate: certificate,
      list_own_property: own_property,
      list_job: job,
      list_health_status_family: [],
    };
  },
  validations: {
    fields: {
      $each: {
        name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name4: { required, minLength: minLength(2), maxLength: maxLength(15) },

        family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
        mother_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
        birth_date: {
          required,
          maxValue(val) {
            if (val != null) {
              val = val.split("-");
              let date = val[2] + "-" + val[1] + "-" + val[0];
              return date <= new Date().toISOString().substring(0, 10);
            }
            return true;
          },
        },
        gender_id: { required },
        marital_status_id: { required },
        certificate_id: { required },

        own_property_id: { required },

        health_status_id: { required },
        relative_relation_id: { required },
        job_id: { required },
        Workplace: {
          required: requiredIf(function (x) {
            return x.job_id == 3;
          }),
          minLength: minLength(2),
          maxLength: maxLength(100),
        },
        attachment_family_health: {
          required: requiredIf(function (x) {
            return x.health_status_id.findIndex((o) => o.id == 1) == -1;
          }),
          fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
          fileSize: fileSize(1024 * 1024 * 5),
        },
        attachment_family_basic: {
          required,
          fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
          fileSize: fileSize(1024 * 1024 * 5),
        },
      },
    },

    form: ["fields"],
  },
  methods: {
    //  Push the row in form
    AddformDataS() {
      // add health status list for every chhild.
      this.list_health_status_family.push(
        health_status.map((x) => {
          return {
            id: x.id,
            name: x.name,
            $isDisabled: false,
          };
        })
      );

      this.fields.push({
        name1: "",
        name2: "",
        name3: "",
        name4: "",
        relative_relation_id: "",

        family_name: "",
        mother_name: "",
        birth_date: "",
        gender_id: "",
        marital_status_id: "",
        certificate_id: "",

        own_property_id: "",

        health_status_id: [],
        job_id: "",
        Workplace: "",
        attachment_family_basic: "",
        attachment_family_health: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
        this.list_health_status_family.splice(index, 1);
      }
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    // getJob
    getJob(index) {
      return this.fields[index].job_id == "3";
    },

    // getHealthStatus
    getHealthStatus(index) {
      return this.fields[index].health_status_id.findIndex((x) => x.id != 1) != -1;
    },

    // multiselect
    onChange(index) {
      for (let i = 0; i < this.list_health_status_family[index].length; i++) {
        this.list_health_status_family[index][i]["$isDisabled"] = false;
      }

      if (this.fields[index].health_status_id.findIndex((o) => o.id == 1) != -1) {
        for (let j = 0; j < this.list_health_status_family[index].length; j++) {
          if (this.list_health_status_family[index][j].id != 1) {
            this.list_health_status_family[index][j]["$isDisabled"] = true;
          }
        }
        this.fields[index].health_status_id = this.fields[index].health_status_id.filter(
          (o) => o.id == 1
        );
      }

      if (this.fields[index].health_status_id.findIndex((o) => o.id == 3) != -1) {
        this.list_health_status_family[index][
          this.list_health_status_family[index].findIndex((o) => o.id == 4)
        ]["$isDisabled"] = true;
      } else if (this.fields[index].health_status_id.findIndex((o) => o.id == 4) != -1) {
        this.list_health_status_family[index][
          this.list_health_status_family[index].findIndex((o) => o.id == 3)
        ]["$isDisabled"] = true;
      }

      if (this.fields[index].health_status_id.findIndex((o) => o.id == 5) != -1) {
        this.list_health_status_family[index][
          this.list_health_status_family[index].findIndex((o) => o.id == 6)
        ]["$isDisabled"] = true;
      } else if (this.fields[index].health_status_id.findIndex((o) => o.id == 6) != -1) {
        this.list_health_status_family[index][
          this.list_health_status_family[index].findIndex((o) => o.id == 5)
        ]["$isDisabled"] = true;
      }
    },

    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات عائلة الجريح</h5></div>
      <ul class="li-attachments">
        <li>يجب ادخال معلومات افراد العائلة الساكنين مع الجريح في نفس البيت .</li>
      </ul>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
              <b-form-input
                id="name1"
                type="text"
                placeholder="ادخل الاسم"
                v-model.trim="field.name1.$model"
                :class="{ 'is-invalid': field.name1.$error }"
              ></b-form-input>
              <div v-if="field.name1.$error" class="invalid-feedback">
                <span v-if="!field.name1.required">هذا الحقل الزامي</span>
                <span v-if="!field.name1.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name1.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
              <b-form-input
                id="name2"
                type="text"
                placeholder="ادخل اسم الاب"
                v-model.trim="field.name2.$model"
                :class="{ 'is-invalid': field.name2.$error }"
              ></b-form-input>
              <div v-if="field.name2.$error" class="invalid-feedback">
                <span v-if="!field.name2.required">هذا الحقل الزامي</span>
                <span v-if="!field.name2.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name2.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
              <b-form-input
                id="name3"
                type="text"
                placeholder="ادخل اسم الجد"
                v-model.trim="field.name3.$model"
                :class="{ 'is-invalid': field.name3.$error }"
              ></b-form-input>
              <div v-if="field.name3.$error" class="invalid-feedback">
                <span v-if="!field.name3.required">هذا الحقل الزامي</span>
                <span v-if="!field.name3.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name3.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
              <b-form-input
                id="name4"
                type="text"
                placeholder="ادخل اسم اب الجد"
                v-model.trim="field.name4.$model"
                :class="{ 'is-invalid': field.name4.$error }"
              ></b-form-input>
              <div v-if="field.name4.$error" class="invalid-feedback">
                <span v-if="!field.name4.required">هذا الحقل الزامي</span>
                <span v-if="!field.name4.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name4.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
              <b-form-input
                id="family_name"
                type="text"
                placeholder="ادخل اللقب"
                v-model.trim="field.family_name.$model"
                :class="{ 'is-invalid': field.family_name.$error }"
              ></b-form-input>
              <div v-if="field.family_name.$error" class="invalid-feedback">
                <span v-if="!field.family_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.family_name.minLength"
                  >يجب أن يتكون اللقب من حرفين على الأقل</span
                >
                <span v-if="!field.family_name.maxLength"
                  >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label="اسم الام الثلاثي : "
              label-for="mother_name"
            >
              <b-form-input
                id="mother_name"
                type="text"
                placeholder="ادخل اسم الام الثلاثي"
                v-model.trim="field.mother_name.$model"
                :class="{ 'is-invalid': field.mother_name.$error }"
              ></b-form-input>
              <div v-if="field.mother_name.$error" class="invalid-feedback">
                <span v-if="!field.mother_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.mother_name.minLength"
                  >يجب أن يتكون اسم الام الثلاثي من حرفين على الأقل</span
                >
                <span v-if="!field.mother_name.maxLength"
                  >يجب أن يتكون اسم الام الثلاثي من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label="تاريخ التولد : "
              label-for="birth_date"
            >
              <date-picker
                id="birth_date"
                type="date"
                lang="ar"
                value-type="DD-MM-YYYY"
                format="DD-MM-YYYY"
                placeholder="اختر تاريخ التولد"
                v-model.trim="field.birth_date.$model"
                :class="{ 'is-invalid': field.birth_date.$error }"
              ></date-picker>
              <div v-if="field.birth_date.$error" class="invalid-feedback">
                <span v-if="!field.birth_date.required">هذا الحقل الزامي </span>
                <span v-if="!field.birth_date.maxValue"
                  >يجب ان لا يتجاوز تاريخ التولد التاريخ اليوم
                </span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label=" الجنس : " label-for="gender_id">
              <select
                class="form-control"
                id="gender_id"
                v-model.trim="field.gender_id.$model"
                :class="{ 'is-invalid': field.gender_id.$error }"
              >
                <option value="">اختر الجنس</option>
                <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                  {{ gender.name }}
                </option>
              </select>
              <div v-if="field.gender_id.$error" class="invalid-feedback">
                <span v-if="!field.gender_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-3 mb-3"
              label=" الحالة الاجتماعية : "
              label-for="marital_status_id"
            >
              <select
                class="form-control"
                id="marital_status_id"
                v-model.trim="field.marital_status_id.$model"
                :class="{ 'is-invalid': field.marital_status_id.$error }"
              >
                <option value="">اختر الحالة الاجتماعية</option>
                <option
                  v-for="marital_status in list_marital_status"
                  :value="marital_status.id"
                  :key="marital_status.id"
                >
                  {{ marital_status.name }}
                </option>
              </select>
              <div v-if="field.marital_status_id.$error" class="invalid-feedback">
                <span v-if="!field.marital_status_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" التحصيل الدراسي : "
              label-for="certificate_id"
            >
              <select
                class="form-control"
                id="certificate_id"
                v-model.trim="field.certificate_id.$model"
                :class="{ 'is-invalid': field.certificate_id.$error }"
              >
                <option value="">اختر التحصيل الدراسي</option>
                <option
                  v-for="certificate in list_certificate"
                  :value="certificate.id"
                  :key="certificate.id"
                >
                  {{ certificate.name }}
                </option>
              </select>
              <div v-if="field.certificate_id.$error" class="invalid-feedback">
                <span v-if="!field.certificate_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" صلة القرابة من مقدم الطلب : "
              label-for="relative_relation_id"
            >
              <select
                class="form-control"
                id="relative_relation_id"
                v-model.trim="field.relative_relation_id.$model"
                :class="{ 'is-invalid': field.relative_relation_id.$error }"
              >
                <option value="">اختر صلة القرابة من مقدم الطلب</option>
                <option
                  v-for="relative_relation in list_relative_relation"
                  :value="relative_relation.id"
                  :key="relative_relation.id"
                >
                  {{ relative_relation.name }}
                </option>
              </select>
              <div v-if="field.relative_relation_id.$error" class="invalid-feedback">
                <span v-if="!field.relative_relation_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" هل تمتلك عقار اخر بأسمك  : "
              label-for="own_property_id"
            >
              <select
                class="form-control"
                id="own_property_id"
                v-model.trim="field.own_property_id.$model"
                :class="{ 'is-invalid': field.own_property_id.$error }"
              >
                <option value="">اختر الاجابة</option>
                <option
                  v-for="own_property in list_own_property"
                  :value="own_property.id"
                  :key="own_property.id"
                >
                  {{ own_property.name }}
                </option>
              </select>
              <div v-if="field.own_property_id.$error" class="invalid-feedback">
                <span v-if="!field.own_property_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-6 mb-3"
              label=" الوضع الصحي  : "
              :label-for="'health_status_id_' + index"
            >
              <multiselect
                :id="'health_status_id_' + index"
                select-label="حدد الاختيار"
                placeholder="اختر الوضع الصحي"
                deselect-label="اظغط هنا لمسح الاختيار"
                selected-label="تم اختياره"
                :options="list_health_status_family[index]"
                track-by="id"
                label="name"
                :close-on-select="false"
                :clear-on-select="false"
                :multiple="true"
                v-model.trim="field.health_status_id.$model"
                @input="onChange(index)"
                :class="{ 'is-invalid': field.health_status_id.$error }"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong>{{ option.name }}</strong> is written in<strong>
                    {{ option.name }}</strong
                  >
                </template>
              </multiselect>
              <div v-if="field.health_status_id.$error" class="invalid-feedback">
                <span v-if="!field.health_status_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-6 mb-3" label=" العمل  : " label-for="job_id">
              <select
                class="form-control"
                id="job_id"
                v-model.trim="field.job_id.$model"
                :class="{ 'is-invalid': field.job_id.$error }"
              >
                <option value="">اختر العمل</option>
                <option v-for="job in list_job" :value="job.id" :key="job.id">
                  {{ job.name }}
                </option>
              </select>
              <div v-if="field.job_id.$error" class="invalid-feedback">
                <span v-if="!field.job_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              v-if="getJob(index)"
              class="col-md-12 mb-3"
              label="مكان العمل : "
              label-for="Workplace"
            >
              <b-form-input
                id="Workplace"
                type="text"
                placeholder="ادخل مكان العمل"
                v-model.trim="field.Workplace.$model"
                :class="{ 'is-invalid': field.Workplace.$error }"
              ></b-form-input>
              <div v-if="field.Workplace.$error" class="invalid-feedback">
                <span v-if="!field.Workplace.required">هذا الحقل الزامي</span>
                <span v-if="!field.Workplace.minLength"
                  >يجب أن يتكون مكان العمل من حرفين على الأقل</span
                >
                <span v-if="!field.Workplace.maxLength"
                  >يجب أن يتكون مكان العمل من 100 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row" v-if="getHealthStatus(index)">
            <b-form-group
              class="col-md-12 mb-3"
              label=" مرفق الوضع الصحي :"
              :label-for="'attachment_family_health' + index"
            >
              <div class="custom_file">
                <b-form-file
                  :id="'attachment_family_health' + index"
                  class=""
                  :data-index="index"
                  placeholder="اختر المرفق"
                  accept=".pdf,.jpg,.jpeg,.png"
                  v-model.trim="field.attachment_family_health.$model"
                  :class="{ 'is-invalid': field.attachment_family_health.$error }"
                  @chnage="chnageFile"
                ></b-form-file>
                <div
                  v-if="field.attachment_family_health.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!field.attachment_family_health.required"
                    >هذا الحقل الزامي</span
                  >
                  <span v-if="!field.attachment_family_health.fileSize"
                    >يجب ان لا يتجاوز حجم الملف 5MB</span
                  >
                  <span v-if="!field.attachment_family_health.fileType"
                    >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <hr class="hr-title" />
            <div class="break-title">
              <h5 class="mb-4">المرفقات الثبوتية</h5>
            </div>
            <ul class="" style="margin-right: 16px">
              <li class="mb-1">
                <h5 class="font-size-14">
                  البطاقة الوطنية او ما يعادلها (هوية الاحوال المدنية + شهادة الجنسية)
                </h5>
              </li>
              <li class="mb-1">
                <h5 class="font-size-14">البطاقة التموينية</h5>
              </li>
              <li class="mb-1">
                <h5 class="font-size-14">بطاقة السكن</h5>
              </li>
              <li class="mb-1">
                <h5 class="font-size-14">
                  يجب جمع المرفقات الثبوتية للفرد اعلاه ورفعها بصيغة ( pdf .jpg .jpeg
                  .png. ) وبحجم لا يتجاوز ( 5MB ) .
                </h5>
              </li>
            </ul>
            <b-form-group
              class="col-md-12 mb-3"
              label=" المرفقات الثبوتية :"
              :label-for="'attachment_family_basic' + index"
            >
              <div class="custom_file">
                <b-form-file
                  :id="'attachment_family_basic' + index"
                  class=""
                  :data-index="index"
                  placeholder="اختر المرفق"
                  accept=".pdf,.jpg,.jpeg,.png"
                  v-model.trim="field.attachment_family_basic.$model"
                  :class="{ 'is-invalid': field.attachment_family_basic.$error }"
                  @chnage="chnageFile"
                ></b-form-file>
                <div v-if="field.attachment_family_basic.$error" class="invalid-feedback">
                  <span v-if="!field.attachment_family_basic.required"
                    >هذا الحقل الزامي</span
                  >
                  <span v-if="!field.attachment_family_basic.fileSize"
                    >يجب ان لا يتجاوز حجم الملف 5MB</span
                  >
                  <span v-if="!field.attachment_family_basic.fileType"
                    >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>

            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
        </div>
        <input
          type="button"
          class="btn btn-primary mt-3 mb-3 mt-lg-0"
          style="width: 100%"
          value="اضافة فرد اخر"
          @click="AddformDataS"
        />
      </form>
    </div>
  </div>
  <!-- end page title -->
</template>
